<template>
<div class="multipane-resizer">
  <slot></slot>
</div>
</template>
